import About from "../../Componant5/About/About";
import Banner from "../../Componant5/Banner/Banner";
import Testimonial from "../../Componant5/Testimonial/Testimonial";
import Blog from "../../Componant5/Blog/Blog";
import Animal from "../../Componant5/Animal/Animal";
import Gallary from "../../Componant5/Gallary/Gallary";
import Events from "../../Componant5/Events/Events";
import Donate from "../../Componant5/Donate/Donate";
import Contact from "../../Componant5/Contact/Contact";

const Home5 = () => {
  return (
    <>
      <Banner />
      <Animal />
      <About />
      <Gallary />
      <Events />
      <Donate />
      <Testimonial />
      <Contact />
      <Blog />
    </>
  );
};

export default Home5;
